/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const foodShopping = useStore((state) => state.foodShopping);
  const setFoodShopping = useStore((state) => state.setFoodShopping);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.foodShopping.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={foodShopping}
          onChange={(value) => {
            setFoodShopping(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'food-shopping',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'healthy'}>
            <span>🥗</span> {t('onboarding.foodShopping.options.healthy')}
          </Option>
          <Option value={'balanced'}>
            <span>💰</span> {t('onboarding.foodShopping.options.balanced')}
          </Option>
          <Option value={'affordable'}>
            <span>🛒</span> {t('onboarding.foodShopping.options.affordable')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
